import { returns } from './function'
import { isUndefined } from './type'

// Bitwise NOT for booleans, coerced to number
export const bitwiseNot = (bool: boolean): number => +!bool

// Parse a number string to integer with optional radix
export const toInt = (number: string, radix: number = 10): number =>
  parseInt(number, radix)

// Format a number with dot separators every 3 digits (thousands separator)
const formatNumber = (value: string): string => {
  const reversed = value.split('').reverse()
  const groups: string[] = []

  for (let i = 0; i < reversed.length; i += 3) {
    groups.push(reversed.slice(i, i + 3).join(''))
  }

  return groups
    .map((group) => group.split('').reverse().join(''))
    .reverse()
    .join('.')
}

// Conditionally format a number-like input as a formatted string
export const formatNumberValue = (value: unknown): string => {
  if (isUndefined(value)) return returns('')()

  const strValue = String(value)
  if (strValue.includes(',')) {
    const [whole] = strValue.split(',')
    return formatNumber(whole)
  }

  return formatNumber(strValue)
}

// Check if a number is a float (i.e., not an integer)
export const isFloat = (n: number): boolean => n % 1 !== 0
